import { Box, Spinner } from 'grommet';
import { ReactNode } from 'react';

export interface IRecalculatingProps {
  /** Whether the value is being recalculated */
  busy: boolean;
  children: ReactNode;
}

/**
 * A number that shows a spinner while it's being recalculated. The number keeps its place (hidden), so
 * nothing around it moves.
 */
export const Recalculating = ({ busy, children }: IRecalculatingProps) => (
  <Box style={{ position: 'relative' }} aria-busy={busy} flex={false}>
    <Box style={{ opacity: busy ? 0 : 1 }}>{children}</Box>
    {busy && (
      <Box a11yTitle="Recalculating" style={{ position: 'absolute', inset: 0 }} align="center" justify="center">
        <Spinner size="xsmall" />
      </Box>
    )}
  </Box>
);
